import React from 'react';
import { styled } from '@linaria/react';

import useRainbow from './use-rainbow.hook';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  id: string;
  intervalDelay?: number;
  children: React.ReactNode;
}

function MagicRainbowButton({
  id,
  children,
  intervalDelay = 1300,
  ...delegated
}: Props) {
  const transitionDelay = intervalDelay * 1.25;

  const colors = useRainbow({ id, intervalDelay });

  const colorKeys = Object.keys(colors);

  return (
    <ButtonElem
      {...delegated}
      style={{
        ...colors,
        transition: `
          ${colorKeys[0]} ${transitionDelay}ms linear,
          ${colorKeys[1]} ${transitionDelay}ms linear,
          ${colorKeys[2]} ${transitionDelay}ms linear
        `,
        background: `
          radial-gradient(
            circle at top left,
            var(${colorKeys[2]}),
            var(${colorKeys[1]}),
            var(${colorKeys[0]})
          )
        `,
      }}
    >
      {children}
    </ButtonElem>
  );
}

const ButtonElem = styled.button`
  position: relative;
  border: none;
  color: white;
  text-align: center;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
`;

export default MagicRainbowButton;
